<template>
    <div class="wallet">
        <WalletContent
            :wallet="wallet"
            :transactions="transactions"
            :loading="loading"
            :loadingNewPage="loadingNewPage"
            :show="show"
            :detailed="detailed"
            @wallet="onWallet"
            @refresh="refresh"
            @page="onChangePage"
            @detailed="onChangeDetailed"
        />
    </div>
</template>

<script>
import WalletContent from "@/components/shared/wallet/content/content.vue";

import {walletFactory} from "@/utils/factory";
import {DEFAULT_PAGE, DEFAULT_PAGE_STEP} from "@/utils/constants.js";
import {getIsShow} from "@/utils/functions.js";

import Api from "@/api/api";

const api = new Api();

export default {
    name: "Wallet",
    components: {
        WalletContent,
    },
    data() {
        return {
            wallet: walletFactory(),
            detailedTransaction: [],
            detailed: false,
            page: DEFAULT_PAGE + DEFAULT_PAGE_STEP,
            loading: false,
            loadingNewPage: false,
            show: true,
        };
    },
    computed: {
        transactions () {
            return this.detailedTransaction
        }
    },
    created() {
        this.onFetchData();
        var helper = document.getElementsByClassName("b24-widget-button-wrapper")
        if (helper && helper[0] && helper[0].style) {
            helper[0].style.display = "none"
        }
    },
    methods: {
        onWallet(wallet) {
            this.wallet = wallet;
        },

        async onChangePage() {
            try {
                this.loadingNewPage = true;

                this.page += DEFAULT_PAGE_STEP;

                await api.transactions(this.page, this.detailed).then((transactions) => {
                    this.detailedTransaction.push(...transactions);
                    this.show = getIsShow(transactions);
                });
            } catch (e) {
                this.loadingNewPage = false;
            } finally {
                this.loadingNewPage = false;
            }
        },

        async onFetchData() {
            this.loading = true;
            try {
                this.wallet = await api.wallet() || walletFactory()
                this.detailedTransaction = await api.transactions(this.page, this.detailed)
                this.show = getIsShow(this.detailedTransaction);
                this.$forceUpdate()
            } finally {
                this.loading = false;
            }
        },

        refresh() {
            location.reload()
        },

        onChangeDetailed() {
            this.detailed = !this.detailed
            this.page = DEFAULT_PAGE + DEFAULT_PAGE_STEP
            this.onFetchData();
        },
    },
};
</script>
